import { io, Socket } from 'socket.io-client'

let socket: Socket | null = null

const SOCKET_URL = import.meta.env.VITE_API_URL

// Connect using httpOnly cookies (no explicit token needed)
export const connectSocket = (): Socket => {
  if (socket?.connected) return socket

  if (!SOCKET_URL) {
    throw new Error('VITE_API_URL is not configured')
  }

  socket = io(SOCKET_URL, {
    withCredentials: true,
    autoConnect: true,
  })

  return socket
}

export const disconnectSocket = () => {
  socket?.disconnect()
  socket = null
}

export const getSocket = () => socket
